/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/

/* SCROLL TOP TOP
--------------------------*/
let ScrollToTop = {
    scrollToTop: function() {
        let element = $('body');
        let offset = element.offset();
        let offsetTop = offset.top;
        $('html, body').animate({scrollTop: offsetTop}, 500, 'linear');
    },

    init: function() {
        let scrollTopWrapper = $('.scroll-top-wrapper');

        $(document).on('scroll', function () {
            if ($(window).scrollTop() > 100) {
                scrollTopWrapper.addClass('show');
            } else {
                scrollTopWrapper.removeClass('show');
            }
        });
        $(document).on('click', '.scroll-top-wrapper', () => {
            this.scrollToTop();
        });
    }
};


export default ScrollToTop;
